<template>
<div>
<h1> Register </h1>

<input type="name" name="name" v-model="name" placeholder="user name"/>
<br/>
<input type="email" name="email" v-model="email" placeholder="email"/>
<br/>
<input type="password" name="password" v-model="password" placeholder="password"/>
<br/>
<input type="password" name="password" v-model="password_repeat" placeholder="password repeat"/>
<br/>

<v-btn @click="register" type="submit" color="success"> Submit </v-btn>
<p v-if="msg"> {{ msg }}</p>
</div>
</template>

<script>
import AuthService from '@/services/AuthService'
export default {
  data () {
    return {
      email: '',
      password: '',
      password_repeat: '',
      name: '',
      msg: ''
    }
  },
  watch: {
    email (value) {
    }
  },
  methods: {
    async register () {
      try {
        const response = await AuthService.register({
          email: this.email,
          password: this.password,
          username: this.name,
          password_repeat: this.password_repeat
        })
        this.msg = response.data.msg
      } catch (error) {
        this.msg = error.response.data.msg
      }
      await new Promise(resolve => setTimeout(resolve, 1000))
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/RegisterComponent.vue